import React from 'react';
import { Marker, Tooltip } from 'react-leaflet';
import { useData } from '../contexts/DataContext';
import L from 'leaflet';

// Default fallback icon
const defaultIcon = new L.Icon({
  iconUrl: 'https://cdn-icons-png.flaticon.com/512/684/684908.png',
  iconSize: [24, 24],
  iconAnchor: [12, 12],
  tooltipAnchor: [0, -12]
});

function getCheckpointIcon(iconFile, title) {
  if (!iconFile) return defaultIcon;

  try {
    const imagePath = require(`../assets/flags/${iconFile}`);
    const isSvg = iconFile.endsWith('.svg');

    const html = `
      <div class="pulse-wrapper" style="text-align: center;">
        <img src="${imagePath}" width="48" height="71"
          style="transform: translateX(-50%); position: absolute; top: 0; left: 50%;" />
        <div style="
          position: absolute;
          top: 75px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 12px;
          color: black;
          font-weight: bold;
          white-space: nowrap;
          background: rgba(255,255,255,0.7);
          padding: 1px 4px;
          border-radius: 3px;
        ">
          ${title}
        </div>
      </div>
    `;

    return L.divIcon({
      className: '',
      html,
      iconSize: [48, isSvg ? 90 : 90],
      iconAnchor: [24, 45],
      tooltipAnchor: [0, -40]
    });
  } catch (err) {
    console.warn(`⚠️ Missing icon file: ${iconFile}, falling back to default.`);
    return defaultIcon;
  }
}


export default function CheckpointMarkers() {
  const { checkpoints } = useData();

  if (!checkpoints?.length) return null;

  return (
    <>
      {checkpoints.map((cp, i) => (
        <Marker
          key={i}
          position={[cp.lat, cp.lon]}
          icon={getCheckpointIcon(cp.icon,cp.title)}
          title={cp.title}
        >
          <Tooltip direction="top" offset={[0, -10]}>{cp.title}</Tooltip>
        </Marker>
      ))}
    </>
  );
}
